import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { ShellRoutingModule } from './shell-routing.module';

import { SideNavigationMenuComponent } from './components/side-navigation-menu/side-navigation-menu.component';
import { ShellComponent } from './components/shell/shell.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { PageNavigationComponent } from './components/page-navigation/page-navigation.component';
import { AtlasBannersModule } from '@wellsky/atlas-ui/banners';
import { BannerExampleComponent } from './components/banner-example/banner-example.component';

@NgModule({
  imports: [
    ShellRoutingModule,
    AtlasBannersModule,
    SharedModule,
  ],
  declarations: [
    ShellComponent,
    SideNavigationMenuComponent,
    HeaderComponent,
    FooterComponent,
    PageNavigationComponent,
    BannerExampleComponent,
  ],
  exports: [
    HeaderComponent,
    SharedModule,
  ]
})
export class ShellModule { }
